// src/components/ExpenseForm.js
import React, { useState, useEffect } from 'react';
import { Tooltip } from 'react-tooltip'; // 引入 ReactTooltip
import 'react-tooltip/dist/react-tooltip.css';
import './Dashboard.css';

function ExpenseForm({ addExpense, editingExpense, handleUpdateExpense, handleCancelEdit }) {
  const [amount, setAmount] = useState('');
  const [category, setCategory] = useState('餐饮');
  const [date, setDate] = useState('');
  const [note, setNote] = useState('');
  const [user, setUser] = useState('爸爸');
  const [type, setType] = useState('支出');

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    if (editingExpense) {
      setAmount(Math.abs(editingExpense.amount));
      setCategory(editingExpense.category);
      setDate(formatDate(new Date(editingExpense.date)));
      setNote(editingExpense.note || '');
      setUser(editingExpense.user);
      setType(editingExpense.amount >= 0 ? '收入' : '支出');
    } else {
      setDate(formatDate(new Date()));
      setAmount('');
      setCategory('餐饮');
      setNote('');
      setUser('爸爸');
      setType('支出');
    }
  }, [editingExpense]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const expenseData = {
      amount: type === '收入' ? parseFloat(amount) : -parseFloat(amount),
      category,
      date,
      note,
      user,
    };

    if (editingExpense) {
      handleUpdateExpense({ ...expenseData, id: editingExpense.id });
    } else {
      addExpense(expenseData);
    }
  };

  const expenseCategoryOptions = [
    { value: '餐饮', icon: '🍽️' },
    { value: '交通', icon: '🚗' },
    { value: '娱乐', icon: '🎉' },
    { value: '购物', icon: '🛒' },
    { value: '教育', icon: '🎓' },
    { value: '医疗', icon: '💊' },
    { value: '往来', icon: '🎁' },
    { value: '其他', icon: '🌟' },
  ];

  const incomeCategoryOptions = [
    { value: '服装', icon: '👕' },
    { value: '造型', icon: '💪' },
    { value: '往来', icon: '🎁' },
    { value: '账号', icon: '📱' },
    { value: '其它', icon: '🌟' },
  ];

  const categoryOptions = type === '支出' ? expenseCategoryOptions : incomeCategoryOptions;

  const userOptions = [
    { value: '爸爸', icon: '👨', className: 'father-option' },
    { value: '妈妈', icon: '👧', className: 'mother-option' },
    { value: '宝贝', icon: '🧸', className: 'baby-option' },
    { value: 'Family', icon: '🏡', className: 'family-option' },
  ];

  return (
    <form onSubmit={handleSubmit}>
      <div className="amount-type-container">
        <div className="type-buttons">
          <button
            type="button"
            className={`type-button expense-button ${type === '支出' ? 'selected' : ''}`}
            onClick={() => {
              setType('支出');
              setCategory('餐饮');
            }}
            data-type="支出"
          >
            <svg
              className="icon"
              xmlns="http://www.w3.org/2000/svg"
              width="100"
              height="100"
              viewBox="0 0 24 24"
              fill="none"
              stroke="black"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
          </button>
          <button
            type="button"
            className={`type-button income-button ${type === '收入' ? 'selected' : ''}`}
            onClick={() => {
              setType('收入');
              setCategory('服装');
            }}
            data-type="收入"
          >
            <svg
              className="icon"
              xmlns="http://www.w3.org/2000/svg"
              width="100"
              height="100"
              viewBox="0 0 24 24"
              fill="none"
              stroke="black"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
          </button>
        </div>
        <input
          type="number"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          placeholder="金额"
          required
        />
      </div>

      <div className='options-container'>
        <div className="option-buttons">
          {categoryOptions.map((option) => (
            <React.Fragment key={option.value}>
              <button
                type="button"
                className={`option-button ${category === option.value ? 'selected' : ''}`}
                onClick={() => setCategory(option.value)}
                data-tooltip-content={option.value}
                data-tooltip-id={`category-tooltip-${option.value}`}
              >
                {option.icon}
              </button>
              <Tooltip id={`category-tooltip-${option.value}`} place="top" effect="solid">
                {option.value}
              </Tooltip>
            </React.Fragment>
          ))}
        </div>
      </div>

      <input
        type="date"
        value={date}
        onChange={(e) => setDate(e.target.value)}
        required
      />
      <input
        type="text"
        value={note}
        onChange={(e) => setNote(e.target.value)}
        placeholder="备注"
      />

      <div className='options-container'>
        <label>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4z"></path>
            <path d="M12 14c-4.41 0-8 2.69-8 6v2h16v-2c0-3.31-3.59-6-8-6z"></path>
          </svg>：
        </label>
        <div className="option-buttons">
          {userOptions.map((option) => (
            <React.Fragment key={option.value}>
              <button
                type="button"
                className={`option-button ${user === option.value ? 'selected' : ''} ${option.className || ''}`}
                onClick={() => setUser(option.value)}
                data-tooltip-content={option.value}
                data-tooltip-id={`user-tooltip-${option.value}`}
              >
                {option.icon}
              </button>
              <Tooltip id={`user-tooltip-${option.value}`} place="top" effect="solid">
                {option.value}
              </Tooltip>
            </React.Fragment>
          ))}
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {editingExpense ? (
          <>
            <button type="button" className="cancel-edit-btn" onClick={handleCancelEdit}>取消</button>
            <button type="submit">更新</button>
          </>
        ) : (
          <button className="submit-btn" type="submit">提交</button>
        )}
      </div>
    </form>
  );
}

export default ExpenseForm;
